import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Store, Select } from '@ngxs/store';
import { FetchOrder } from 'src/app/core/store/order/order.actions';
import { OrderState } from 'src/app/core/store/order/order.state';
import { OrderDetails, Patient } from 'src/app/core/models';
import { PatientState } from 'src/app/core/store/patient/patient.state';
import { CcsSentryError } from 'src/app/core/store/utils';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss'],
})
export class OrderDetailsComponent implements OnInit {
  @Select(OrderState.isLoading) isLoading$!: Observable<boolean>;
  @Select(OrderState.error) error$!: Observable<CcsSentryError | null>;
  @Select(OrderState.order) order$!: Observable<OrderDetails>;
  @Select(PatientState.patient) patient$!: Observable<Patient | null>;

  constructor(private store: Store, private route: ActivatedRoute) {}

  ngOnInit(): void {
    const orderId = parseInt(this.route.snapshot.paramMap.get('orderId')!);
    this.store.dispatch(new FetchOrder(orderId));
  }
}
